import { createAuthClient } from '@paperair/auth-client'
import { SYSTEM_APP_IDS } from '@paperair/shared-types'
import { useAuthStore } from '../stores/authStore'

/**
 * Passport's instance of the shared auth client. Same base URL convention as `apiClient`
 * (dev: Vite-proxied `/api`, staging/prod: `VITE_API_URL` directly). `getAccessToken` reads
 * live from the store rather than being bound once, since the token changes across login/
 * refresh/logout.
 */
export const authClient = createAuthClient({
  baseUrl: import.meta.env.VITE_API_URL || '/api',
  appId: SYSTEM_APP_IDS.AUTH_ADMIN,
  getAccessToken: () => useAuthStore.getState().accessToken,
})
